(() => {
  if (window.FreshPrintsLargeFormatDefaults) {
    window.FreshPrintsLargeFormatDefaults.scan();
    return;
  }

  const pickerSelector = '[data-fp-large-format-picker]';
  const explicitSelectionParameters = ['variant', 'option_values'];

  function isUnlaminated(value) {
    const normalized = String(value || '')
      .trim()
      .toLowerCase()
      .replace(/[_-]+/g, ' ')
      .replace(/\s+/g, ' ');

    return [
      'unlaminated',
      'non laminate',
      'non laminated',
      'no laminate',
      'without laminate',
    ].includes(normalized);
  }

  function hasExplicitVariantSelection(picker) {
    if (picker.dataset.updateUrl === 'false') return false;

    const parameters = new URLSearchParams(window.location.search);
    return explicitSelectionParameters.some((parameter) => parameters.has(parameter));
  }

  function getVariants(picker) {
    const data = picker.querySelector('script[type="application/json"]');
    if (!data?.textContent) return [];

    try {
      const variants = JSON.parse(data.textContent);
      return Array.isArray(variants) ? variants : [];
    } catch (_error) {
      return [];
    }
  }

  function applyDefault(picker) {
    if (!picker || picker.dataset.fpUnlaminatedDefaultApplied === 'true') return;
    picker.dataset.fpUnlaminatedDefaultApplied = 'true';

    if (hasExplicitVariantSelection(picker)) return;

    const selects = [...picker.querySelectorAll('select')];
    const finishIndex = selects.findIndex((select) =>
      [...select.options].some((option) => isUnlaminated(option.value)),
    );

    if (finishIndex < 0) return;

    const finishSelect = selects[finishIndex];
    const unlaminatedOption = [...finishSelect.options].find((option) => isUnlaminated(option.value));
    if (!unlaminatedOption || finishSelect.value === unlaminatedOption.value) return;

    const variants = getVariants(picker);
    const currentOptions = selects.map((select) => select.value);
    let defaultVariant = variants.find(
      (variant) =>
        variant.available &&
        variant.options?.[finishIndex] === unlaminatedOption.value &&
        variant.options.every((value, index) => index === finishIndex || value === currentOptions[index]),
    );

    defaultVariant ||= variants.find(
      (variant) => variant.available && variant.options?.[finishIndex] === unlaminatedOption.value,
    );

    if (!defaultVariant) return;

    selects.forEach((select, index) => {
      if ([...select.options].some((option) => option.value === defaultVariant.options[index])) {
        select.value = defaultVariant.options[index];
      }
    });

    finishSelect.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function scan(root = document) {
    root.querySelectorAll(pickerSelector).forEach(applyDefault);
  }

  window.FreshPrintsLargeFormatDefaults = { scan };

  customElements.whenDefined('variant-selects').then(() => scan());
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
